import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  referrerpolicy: "no-referrer",
  src: "https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngee623e053d894bb090d9f5f197360793a874e70628bcf52c2fb0cb3793a12ca1"
}, null, -1)
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['upload-picture', _ctx.$style.upload_content])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.upload_wrap)
      }, [
        _createVNode(_component_a_upload, {
          ref: "uploadRef",
          name: _ctx.name,
          "file-list": _ctx.fileList,
          "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileList = $event)),
          "list-type": _ctx.type,
          customRequest: _ctx.ossRequest,
          "before-upload": _ctx.handleBeforeUpload,
          accept: _ctx.accepts,
          onChange: _ctx.handleChange,
          onPreview: _ctx.handlePreview
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              (!(!_ctx.isEdit || _ctx.fileList.length >= _ctx.maxlength))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.upload_btn)
                  }, [
                    _hoisted_1,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.upload.label')) + " " + _toDisplayString(_ctx.title), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 3
        }, 8, ["name", "file-list", "list-type", "customRequest", "before-upload", "accept", "onChange", "onPreview"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.example]),
        style: _normalizeStyle({backgroundImage: `url(${_ctx.example})`})
      }, null, 6)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.label_row)
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.$style.label)
      }, _toDisplayString(_ctx.title), 3),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.$style.label)
      }, _toDisplayString(_ctx.$t('common.example')), 3)
    ], 2),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      footer: null,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: _ctx.image
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}